<template>
  <pack-lead-widget-table :list="list" :packId="packId"></pack-lead-widget-table>
</template>

<script>
import releaseNoteApi from "@/api/releaseNote";
import PackLeadWidgetTable from "./PackLeadWidgetTable.vue";

export default {
  components: {
    PackLeadWidgetTable,
  },
  computed: {
    packId() {
      return this.$route.params.packId;
    },
  },
  async created() {
    await this.refreshList();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async refreshList() {
      const documentationStatusFilter = {
        attributeName: "documentationStatus",
        attributeNameLabel: "Documentation Status",
        dataType: "string",
        operator: "in",
        operatorLabel: "=",
        value: ["Pending Review"],
        valueLabel: "Pending Review",
        valueType: "array",
      };

      let result;
      try {
        result = await releaseNoteApi.packDashboardWidgetSearch({
          filterList: [documentationStatusFilter],
          packId: this.packId,
        });
        this.list = result;
      } catch (e) {
        console.error(e);
        this.$notifyError({
          message: `Could not refresh list of published release notes.`,
        });
      }
    },
  },
  watch: {
    async packId() {
      await this.refreshList();
    },
    list(val) {
      this.$emit("noteCount", val.length);
    },
  },
};
</script>
